var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4601 6.24023L6.24024 29.4601C3.25325 32.4471 3.25325 37.2899 6.24024 40.2769C9.22722 43.2639 14.0701 43.2639 17.0571 40.2769L27.2199 30.1141L27.2199 58.3514C27.2199 62.5756 30.6443 66 34.8685 66C39.0927 66 42.5172 62.5756 42.5172 58.3513L42.5172 30.1141L52.68 40.2769C55.6669 43.2639 60.5098 43.2639 63.4968 40.2769C66.4838 37.2899 66.4838 32.4471 63.4968 29.4601L40.2769 6.24023C37.2899 3.25326 32.4471 3.25326 29.4601 6.24023Z",
    stroke: "#0C1318",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.06866 32.2885L32.2885 9.06866C33.7134 7.64378 36.0236 7.64378 37.4485 9.06866L60.6683 32.2885C62.0932 33.7134 62.0932 36.0236 60.6683 37.4485C59.2435 38.8734 56.9333 38.8734 55.5084 37.4485L38.5172 20.4573L38.5172 58.3514C38.5172 60.3664 36.8836 62 34.8685 62C32.8534 62 31.2199 60.3664 31.2199 58.3514L31.2199 20.4573L14.2286 37.4485C12.8037 38.8734 10.4935 38.8734 9.06866 37.4485C7.64378 36.0236 7.64378 33.7134 9.06866 32.2885Z",
    fill: "url(#paint0_linear_5246_143777)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3014 30.1471C34.6797 30.1447 34.1776 29.6386 34.18 29.0169L34.2795 21.5877C34.282 20.9659 34.788 20.4639 35.4098 20.4663C36.0316 20.4688 36.5336 20.9748 36.5312 21.5965L36.4317 29.0257C36.4292 29.6475 35.9232 30.1496 35.3014 30.1471Z",
    fill: "#F7FCFD",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5246_143777",
    x1: 17.7704,
    y1: 50.9796,
    x2: 31.2197,
    y2: 0.372759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F95370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA87D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrease);
export default __webpack_public_path__ + "static/media/increase.10f587fef951b52806e0e0fced9c62a8.svg";
export { ForwardRef as ReactComponent };